var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"posters-overlay"},_vm._l((_vm.posters),function(poster){return _c('div',{staticClass:"poster"},[_c('img',{attrs:{"src":"assets/images/poster.jpg"}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4e815cc","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sections/amerikkkan/_components/poster-overlay.vue
// module id = 565
// module chunks = 0